import {
    Show,
    useTranslate,
    useGetOne,
    DeleteWithConfirmButton,
    TopToolbar,
    useNotify,
    useRedirect,
    usePermissions
}
    from 'react-admin';
import BasicBreadcrumbs from '../../components/breadcrumb';
import { useParams } from 'react-router-dom';
import { CustomInstanceShow } from '../../custom';


const CustomDeleteButton = (props) => {
    const translate = useTranslate();
    const notify = useNotify();
    const redirect = useRedirect();
    const { permissions, isLoading } = usePermissions();

    const title = `${translate('app.vms.delete.title')} ${props.record.name}`;

    const handleSuccess = () => {
        notify(translate('app.vms.delete.successMessage'), { type: 'info' });

        // Only redirect if user has list access
        if (permissions?.includes('admin')) {
            redirect('list', 'vms'); // or your resource name
        } else {
            redirect('/');
        }
    };

    return (
        <DeleteWithConfirmButton
            confirmTitle={title}
            confirmContent={translate('app.vms.delete.confirmMessage')}
            mutationOptions={{ onSuccess: handleSuccess }}
            {...props}
        />
    );
};

const Actions = ({ record }) => {
    const { permissions, isLoading } = usePermissions();

    if (isLoading) return null;

    const isTraineeOnly = permissions.length === 1 && permissions.includes('trainee');

    return (
        <TopToolbar>
            {/* Show delete only if not trainee */}
            {!isTraineeOnly && <CustomDeleteButton record={record} />}
        </TopToolbar>
    );
};


const VmShowInPod = (props) => {
    const translate = useTranslate();
    const { id, vmId } = useParams();
    const { data: vmData, isLoading, error } = useGetOne('vms', { id: vmId });
    const { data: podData, isLoading: isLoading2, error: error2 } = useGetOne('pods', { id });

    if (isLoading) return <div>{translate('app.LoadingMessage')}</div>;
    if (isLoading2) return <div>{translate('app.LoadingMessage')}</div>;

    if (error) return <div>{translate('app.ErrorMessage')}</div>;
    if (error2) return <div>{translate('app.ErrorMessage')}</div>;

    return (
        <>
            <BasicBreadcrumbs name={podData.name} name2={vmData.name} />
            <Show actions={<Actions record={vmData} />} id={vmId}
                resource="vms"
                redirect={false}>
                <CustomInstanceShow record={vmData} />
            </Show>
        </>
    );
};

const VmShowInMyPod = (props) => {
    const translate = useTranslate();
    const { vmId } = useParams();
    const { data: vmData, isLoading, error } = useGetOne('vms', { id: vmId });
    if (isLoading) return <div>{translate('app.LoadingMessage')}</div>;
    if (error) return <div>{translate('app.ErrorMessage')}</div>;

    return (
        <>
            <BasicBreadcrumbs name={vmData.name} />
            <Show actions={<Actions record={vmData} />} id={vmId}
                resource="vms"
                redirect={false}>
                <CustomInstanceShow record={vmData} />
            </Show>
        </>
    );
};


export { VmShowInPod, VmShowInMyPod };